import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

interface LoadingStateProps {
	center?: boolean;
	message: string;
}

const LoadingState: FC<LoadingStateProps> = ({center, message}) => (
	<div className={classNames({
		[styles.bulk]: true,
		[styles.center]: center,
	})}>
		<div className={styles.loading}>
			{message}
		</div>
	</div>
);

export default LoadingState;
